import { atom } from 'recoil'

export const modalShowHistoryState = atom({
  key: 'SourceEdit__modalShowHistoryState',
  default: {
    show: false,
    loading: false,
    loaded: false,
    updateHistory: [],
    otherActivity: undefined,
    callNum: -1
  }
})

export const modalSharedListsState = atom({
  key: 'SourceEdit__modalSharedListsState',
  default: {
    show: false,
    sharedLists: [],
    selectAll: false,
    blockedLists: []
  }
})
